// extracted by mini-css-extract-plugin
module.exports = {"creditTag":"CreditTag_creditTag__LQKP2"};